<h2 class="title" *ngIf="data.title">{{ data.title | translate }}</h2>
<form class="board-modal" [formGroup]="form">
  <mat-form-field appearance="fill">
    <mat-label>{{ 'board-modal.title' | translate }}</mat-label>
    <input matInput formControlName="title" />
    <mat-error *ngIf="form.invalid">{{ 'validators.common.required' | translate }}</mat-error>
  </mat-form-field>
  <div mat-dialog-actions>
    <app-button-multicolor [buttons]="buttons" (navigate)="navigate($event)"></app-button-multicolor>
  </div>
</form>
